import React from 'react';
import { ProfilesBox } from 'new/elements/ProfilesBox';
import { User } from 'new/entities/User';
import { useHistory } from 'react-router-dom';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_COLLABORATE_SHARED_USERS } from 'new/constants/pathnames';
import { router } from 'new/routes/router';
import { UserDetail } from 'new/components/collaborate/org';

interface SharedResourcesToProps {
  users: User[];
}

export function SharedResourcesTo(props: SharedResourcesToProps) {
  const { users } = props;
  const history = useHistory();

  const onClickProfile = (profile) => {
    history.push(
      router.manager.getPath(UserDetail.screenConfig.screenName, 'collaborate', [profile.id]),
    );
  };

  const onClickAll = () => {
    history.push(`${ROUTE_REDESIGN}${ROUTE_COLLABORATE_SHARED_USERS}`, {
      users,
    });
  };

  return (
    <ProfilesBox
      title="Shared resources to"
      onClickProfile={onClickProfile}
      rightAction={{
        title: 'View all',
        onClick: onClickAll,
      }}
      profiles={props.users
        .slice(0, 8)
        .map((user) => ({ ...user, name: user.full_name, badge: '9' }))}
    />
  );
}
